import { useContext, useEffect } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import CardBox, { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Button from "components/ui/controls/button/button";
import { FaCalculator, FaSync, FaChartPie, FaCoins, FaShieldAlt } from "react-icons/fa";
import { CalculResultatEntreprise } from "components/app/Api/Remuneration/ApiRemuneration";
import "components/ui/controls/card-box/card-box.css";
import { createStyledButton } from "components/ui/controls/button/button-styles";

function ModalParamDividendes(props) {
  const context = useContext(AppContext);
  useEffect(() => {
    if (context.state[props.Outil + "SetSeuilAssuj"] === false) {
      CalculResultatEntreprise(context.state, props.Outil).then((ResultatEntreprise) => {
        context.handleValueChange(props.Outil + "SeuilAssuj", ResultatEntreprise.SeuilAssuj);
      });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.state[props.Outil + "SetSeuilAssuj"]]);

  useEffect(() => {
    if (context.state[props.Outil + "SetSeuilAssujConjoint"] === false) {
      if (props.Outil === "OptiRem" && props.ClientConjoint === "Conjoint") {
        context.handleCalculResultatEntrepriseConjointOptiRem(props.Outil + "PeriodeConjoint", props.Outil + "CapitalSocial" + props.ClientConjoint);
      } else {
        CalculResultatEntreprise(context.state, props.Outil).then((ResultatEntreprise) => {
          context.handleValueChange(props.Outil + "SeuilAssujConjoint", ResultatEntreprise.SeuilAssujConjoint);
        });
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.state[props.Outil + "SetSeuilAssujConjoint"]]);
  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            <Row>
              <CardBoxHeader icon={<FaChartPie />}>
                <span>Détention capitalistique</span>
              </CardBoxHeader>
            </Row>
            {props.ClientConjoint === "" ? (
              <>
                <Row>
                  <Column>
                    <TextField
                      label="Capital social"
                      value={context.state[props.Outil + "CapitalSocial" + props.ClientConjoint]}
                      onChange={context.handleInputChange(props.Outil + "CapitalSocial" + props.ClientConjoint)}
                      onBlur={(e) => {
                        context.handleCalculResultatEntreprise(props.Outil, props.Outil + "CapitalSocial" + props.ClientConjoint, e);
                      }}
                      xlarge
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                    />
                  </Column>
                </Row>
                <Row>
                  <Column>
                    <TextField
                      label={"Détention capitalistique " + context.state.Prenom}
                      value={context.state[props.Outil + "PartSoc"]}
                      onBlur={(e) => context.handleCalculResultatEntreprise(props.Outil, props.Outil + "PartSoc", e)}
                      xlarge
                      dataType="ufloat"
                      format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                    />
                  </Column>
                  {context.state.InclureConjoint && (
                    <Column lpad>
                      <TextField
                        label={"Détention capitalistique " + context.state.PrenomConjoint}
                        value={context.state[props.Outil + "PartSocConj"]}
                        onBlur={(e) => context.handleCalculResultatEntreprise(props.Outil, props.Outil + "PartSocConj", e)}
                        disabled={context.state[props.Outil + "PartSoc"] === 100}
                        xlarge
                        dataType="ufloat"
                        format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                      />
                    </Column>
                  )}
                </Row>
              </>
            ) : (
              <>
                <Row>
                  <Column>
                    <TextField
                      label="Capital social"
                      value={context.state[props.Outil + "CapitalSocial" + props.ClientConjoint]}
                      onChange={context.handleInputChange(props.Outil + "CapitalSocial" + props.ClientConjoint)}
                      onBlur={(e) => {
                        context.handleCalculResultatEntrepriseConjointOptiRem(props.Outil + "PeriodeConjoint", props.Outil + "CapitalSocial" + props.ClientConjoint, e);
                      }}
                      xlarge
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                    />
                  </Column>
                </Row>
                <Row>
                  <Column>
                    <TextField
                      label={"Détention capitalistique " + context.state.PrenomConjoint}
                      value={context.state[props.Outil + "PeriodeConjointPartSoc"]}
                      onBlur={(e) => context.handleCalculResultatEntrepriseConjointOptiRem(props.Outil + "PeriodeConjoint", props.Outil + "PeriodeConjointPartSoc", e)}
                      xlarge
                      dataType="ufloat"
                      format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                    />
                  </Column>
                  {context.state.InclureConjoint && (
                    <Column lpad>
                      <TextField
                        label={"Détention capitalistique " + context.state.Prenom}
                        value={context.state[props.Outil + "PeriodeConjointPartSocConj"]}
                        onBlur={(e) => context.handleCalculResultatEntrepriseConjointOptiRem(props.Outil + "PeriodeConjoint", props.Outil + "PeriodeConjointPartSocConj", e)}
                        disabled={context.state[props.Outil + "PeriodeConjointPartSoc"] === 100}
                        xlarge
                        dataType="ufloat"
                        format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                      />
                    </Column>
                  )}
                </Row>
              </>
            )}

            <Row>
              <CardBoxHeader icon={<FaCoins />}>
                <span>Résultat distribué</span>
              </CardBoxHeader>
            </Row>
            <Row tpad>
              <Column>
                <TextField
                  value={context.state[props.Outil + "Reserve" + props.ClientConjoint]}
                  label="Mise en réserve"
                  normal
                  onChange={context.handleInputChange(props.Outil + "Reserve" + props.ClientConjoint)}
                  dataType="uint"
                  format={{ thousands: " ", unit: " €" }}
                />
              </Column>
            </Row>
            
            <Row>
              <CardBoxHeader icon={<FaShieldAlt />}>
                <span>Régime social des dividendes</span>
              </CardBoxHeader>
            </Row>
            {props.ClientConjoint === "" ? (
              <>
                <Row>
                  <div
                    style={{
                      backgroundColor: "white",
                      border: "1px solid #e5e7eb",
                      borderRadius: "12px",
                      padding: "16px",
                      width: "100%",
                      minHeight: "96px",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                      marginBottom: "12px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div
                          style={{
                            width: "48px",
                            height: "48px",
                            borderRadius: "50%",
                            backgroundColor: "#dbeafe",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <FaCalculator style={{ fontSize: "16px", color: "#3b82f6" }} />
                        </div>
                        <div>
                          <div style={{ fontSize: "12px", fontWeight: "600", color: "#1f2937", marginBottom: "2px" }}>Seuil d'assujetissement pour {context.state.Prenom}</div>
                          <div style={{ fontSize: "12px", color: "#6b7280" }}>{context.state[props.Outil + "SetSeuilAssuj"] === false ? "Calculé automatiquement" : "Saisi manuellement"}</div>
                        </div>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <Button
                          tabIndex="-1"
                          icon
                          onClick={() => context.handleValueChange(props.Outil + "SetSeuilAssuj", false)}
                          {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                        >
                          {context.state[props.Outil + "SetSeuilAssuj"] === false ? (
                            <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} />
                          ) : (
                            <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />
                          )}
                        </Button>
                        <TextField
                          value={context.state[props.Outil + "SeuilAssuj"]}
                          onChange={(e) => {
                            context.handleValueChange(props.Outil + "SetSeuilAssuj", true);
                            context.handleValueChange(props.Outil + "SeuilAssuj", e.target.value);
                          }}
                          dataType="uint"
                          format={{ thousands: " ", unit: " €" }}
                          small
                          style={{ minWidth: "80px", fontSize: "12px" }}
                        />
                      </div>
                    </div>
                  </div>
                </Row>
                {props.Periode?.StatutConjoint === "TNS Article 62" && (
                  <Row>
                    <div
                      style={{
                        backgroundColor: "white",
                        border: "1px solid #e5e7eb",
                        borderRadius: "12px",
                        padding: "16px",
                        width: "100%",
                        minHeight: "96px",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                        marginBottom: "12px",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                          <div
                            style={{
                              width: "48px",
                              height: "48px",
                              borderRadius: "50%",
                              backgroundColor: "#dbeafe",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <FaCalculator style={{ fontSize: "16px", color: "#3b82f6" }} />
                          </div>
                          <div>
                            <div style={{ fontSize: "12px", fontWeight: "600", color: "#1f2937", marginBottom: "2px" }}>Seuil d'assujetissement pour {context.state.PrenomConjoint}</div>
                            <div style={{ fontSize: "12px", color: "#6b7280" }}>{context.state[props.Outil + "SetSeuilAssujConjoint"] === false ? "Calculé automatiquement" : "Saisi manuellement"}</div>
                          </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <Button
                            tabIndex="-1"
                            icon
                            onClick={() => context.handleValueChange(props.Outil + "SetSeuilAssujConjoint", false)}
                            {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                          >
                            {context.state[props.Outil + "SetSeuilAssujConjoint"] === false ? (
                              <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} />
                            ) : (
                              <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />
                            )}
                          </Button>
                          <TextField
                            value={context.state[props.Outil + "SeuilAssujConjoint"]}
                            onChange={(e) => {
                              context.handleValueChange(props.Outil + "SetSeuilAssujConjoint", true);
                              context.handleValueChange(props.Outil + "SeuilAssujConjoint", e.target.value);
                            }}
                            dataType="uint"
                            format={{ thousands: " ", unit: " €" }}
                            small
                            style={{ minWidth: "80px", fontSize: "12px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </Row>
                )}
              </>
            ) : (
              <>
                {context.state.InclureConjoint && (
                  <Row>
                    <div
                      style={{
                        backgroundColor: "white",
                        border: "1px solid #e5e7eb",
                        borderRadius: "12px",
                        padding: "16px",
                        width: "100%",
                        minHeight: "96px",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                        marginBottom: "12px",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                          <div
                            style={{
                              width: "48px",
                              height: "48px",
                              borderRadius: "50%",
                              backgroundColor: "#dbeafe",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <FaCalculator style={{ fontSize: "16px", color: "#3b82f6" }} />
                          </div>
                          <div>
                            <div style={{ fontSize: "12px", fontWeight: "600", color: "#1f2937", marginBottom: "2px" }}>Seuil d'assujetissement pour {context.state.PrenomConjoint}</div>
                            <div style={{ fontSize: "12px", color: "#6b7280" }}>{context.state[props.Outil + "SetSeuilAssujConjoint"] === false ? "Calculé automatiquement" : "Saisi manuellement"}</div>
                          </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <Button
                            tabIndex="-1"
                            icon
                            onClick={() => context.handleValueChange(props.Outil + "SetSeuilAssujConjoint", false)}
                            {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                          >
                            {context.state[props.Outil + "SetSeuilAssujConjoint"] === false ? (
                              <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} />
                            ) : (
                              <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />
                            )}
                          </Button>
                          <TextField
                            value={context.state[props.Outil + "SeuilAssujConjoint"]}
                            onChange={(e) => {
                              context.handleValueChange(props.Outil + "SetSeuilAssujConjoint", true);
                              context.handleValueChange(props.Outil + "SeuilAssujConjoint", e.target.value);
                            }}
                            dataType="uint"
                            format={{ thousands: " ", unit: " €" }}
                            small
                            style={{ minWidth: "80px", fontSize: "12px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </Row>
                )}
              </>
            )}
          </Column>
        </CardBox>
      </Column>
    </>
  );
}

export default ModalParamDividendes;
